import React, { PureComponent } from 'react';
import { Link, scrollSpy } from 'react-scroll';
import styles from './Footer.css';
import { gcpURL } from '../../lib/utils';

const icon17 = `${gcpURL}/static/logo_with_name.svg`;

const A = ({ text, className, ...props }) => (
  <a
    className={`${styles.navItem} ${className}`}
    target="_blank"
    rel="noopener noreferrer"
    data-ga-on="click"
    data-ga-event-category="Header"
    data-ga-event-action={text}
    {...props}
  >
    {text}
  </a>
);

const NavItem = ({ children, text, className, ...props }) => (
  <Link
    {...props}
    className={`${styles.navItem} ${className}`}
    smooth
    spy
    offset={-60}
    duration={500}
    to={text}
    activeClass={styles.isActive}
    rel="noopener noreferrer"
    data-ga-on="click"
    data-ga-event-category="Footer"
    data-ga-event-action={text}
  >
    {text}
    {children}
  </Link>
);

class Footer extends PureComponent {
  componentDidMount() {
    scrollSpy.update();
  }

  render() {
    return (
      <div className={styles.footer}>
        <div className={styles.navList}>
          <div>
            <A text="如何支持喜愛主播" href="http://17.media/event/goldenfeather" />
            <A text="如何成為人氣主播" href="mailto:ginabd@17.media" />
          </div>
          <div className={`${styles.logo}`}>
            <a href="http://17.media/">
              <img src={icon17} alt="17 Media" />
            </a>
          </div>
          <div>
            <A text="更多關於金羽獎" href="https://www.facebook.com/17app" />
            <A text="廣告合作洽談" href="mailto:marketing@17.media" />
          </div>
        </div>
        <div className={styles.copyright2016By}>
          Copyright © 2016 by 17Media. All rights reserved.
        </div>
      </div>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/sections/Footer/index.js